import { render } from "./Set-Solar.vue?vue&type=template&id=52e6069c"
import script from "./Set-Solar.vue?vue&type=script&lang=js"
export * from "./Set-Solar.vue?vue&type=script&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__